import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Row, Text } from '@cuemath/comps';
import PropTypes from 'prop-types';

const Field = styled.div`
  width: 65%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ profileView }) => `${profileView ? '10px' : '12px'}`};
`;

const Label = styled.label`
  width: 25%;
  display: flex;
  justify-content: left;
`;

const Flex = styled.div`
  width: 75%;
  display: flex;
  gap: ${({ gap }) => `${gap ? '10px' : '20px'}`};
`;

const GridItems = styled(Row)`
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const RadioText = styled(Text)`
  margin-left: 5px;
  bottom: 4px;
  position: relative;
`;

const Input = styled.input`
  height: 16px;
  width: 16px;
`;

const LOCATION = ['CW', 'HW', 'ANY'];
const IS_TIMED = ['Yes', 'No'];
const FILTER = {
  LOCATION: 'location',
};

export default class RadioForm extends PureComponent {
  static propTypes = {
    selectedValue: PropTypes.shape({}).isRequired,
    handleRadioButtonChange: PropTypes.func.isRequired,
  };

  render() {
    const { selectedValue, value, disabled, handleRadioButtonChange } = this.props;
    const { name: tagName } = selectedValue || {};
    const MAP = selectedValue.name === FILTER.LOCATION ? LOCATION : IS_TIMED;
    return (
      <Field justifyContent>
        <Label>{selectedValue.label}</Label>
        <Flex>
          {MAP &&
            MAP.map(item => {
              return (
                <GridItems key={`radio_type_${item}`}>
                  <label>
                    <Row>
                      <Input
                        type="radio"
                        disabled={disabled}
                        name={tagName}
                        onChange={e => handleRadioButtonChange(e, item)}
                        checked={value === item}
                      />
                      <RadioText>{item}</RadioText>
                    </Row>
                  </label>
                </GridItems>
              );
            })}
        </Flex>
      </Field>
    );
  }
}
